if (!customElements.get('qa-collapsible-row')) {
  class QaCollapsibleRow extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.qa-ragdoll-content');
      if (!this.details || !this.summary || !this.content) return;
      this.summary.addEventListener('click', (event) => this.toggle(event));
    }
    toggle(event) {
      event.preventDefault();
      if (this.animating) return;
      this.details.style.overflow = 'hidden';
      this.details.open ? this.close() : this.open();
    }
    close() {
      this.animating = true;
      const animation = this.details.animate({height:[`${this.details.offsetHeight}px`,`${this.summary.offsetHeight}px`]}, {duration:300,easing:'ease'});
      animation.onfinish = () => this.finish(false);
      animation.oncancel = () => this.finish(this.details.open);
    }
    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      requestAnimationFrame(() => {
        this.animating = true;
        const animation = this.details.animate({height:[`${this.summary.offsetHeight}px`,`${this.summary.offsetHeight + this.content.offsetHeight}px`]}, {duration:400,easing:'ease-out'});
        animation.onfinish = () => this.finish(true);
        animation.oncancel = () => this.finish(true);
      });
    }
    finish(open) {
      this.details.open = open;
      this.animating = false;
      this.details.style.height = '';
      this.details.style.overflow = '';
    }
  }
  customElements.define('qa-collapsible-row', QaCollapsibleRow);
}
